import { useGetSetBackground, useIsSpecialCardSet } from '@sorare/core/src/set';

type Props = {
  setSlug: Nullable<string>;
};

export const CollectionSetBackground = ({ setSlug }: Props) => {
  const getSetBackground = useGetSetBackground();
  const isSpecialCardSet = useIsSpecialCardSet();
  if (isSpecialCardSet(setSlug)) {
    return <div style={getSetBackground(setSlug as string)} />;
  }
  return null;
};
